import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { FormattedMessage } from '@flipster/i18n';
import { useOverlay } from '@flipster/overlay';
import { IconButton } from '@flipster/react/design-system/icon-button';
import { Modal } from '@flipster/react/design-system/modal';
import Formatted from '@flipster/react/design-utils/formatted';
import InformationCircleIcon from '@flipster/react/icon/generated/InformationCircleIcon';
import { css } from '@flipster/styled-system/css';
import { hstack, stack } from '@flipster/styled-system/patterns';
import { token } from '@flipster/styled-system/tokens';
import { UsdtCurrency, UsdtPrecision } from '@flipster/utils/constants/currency';

import { rewardHubV2Bunja } from '../state';

export const TotalRewardBanner = () => {
  const overlay = useOverlay();

  const { totalClaimedRewardAtom } = useBunja(rewardHubV2Bunja);
  const totalClaimedReward = useAtomValue(totalClaimedRewardAtom);

  return (
    <section className={css({ py: 24, px: 16, bgColor: 'background.default.level-3', smallDesktop: { rounded: 8 } })}>
      <div className={stack({ gap: 4 })}>
        <div className={hstack({ textStyle: 'Text/M/Strong', color: 'content.default.level-5' })}>
          <FormattedMessage id='Autogen_common.r251126.s_Total_rewards' />
          <IconButton
            hierarchy='quaternary'
            size='small'
            icon={<InformationCircleIcon color={token('colors.content.default.level-1')} />}
            onClick={() =>
              overlay.open(({ isOpen, onClose, unmount }) => (
                <TotalRewardDescriptionModal isOpen={isOpen} onClose={onClose} onExit={unmount} />
              ))
            }
          />
        </div>
        <p className={css({ textStyle: 'Title/L', color: 'content.accent.promotion' })}>
          <Formatted.Number
            value={totalClaimedReward}
            precision={UsdtPrecision}
            suffix={UsdtCurrency}
            zeroString='0'
            toFixed
            css={{ textStyle: 'Title/L' }}
          />
        </p>
      </div>
    </section>
  );
};

const TotalRewardDescriptionModal = ({
  isOpen,
  onClose,
  onExit,
}: {
  isOpen: boolean;
  onClose: () => void;
  onExit: () => void;
}) => {
  return (
    <Modal.Root isOpen={isOpen} onClose={onClose} onExit={onExit} mode='bottomSheet'>
      <Modal.Header>
        <Modal.Title label={<FormattedMessage id='Autogen_common.r251126.s_Total_rewards' />} />
      </Modal.Header>
      <Modal.Content
        css={{
          textStyle: 'Text/M/Regular',
          color: 'content.default.level-3',
          whiteSpace: 'pre-line',
        }}
      >
        <FormattedMessage id='Reward_hub.r260128.Total_reward_description1' />
        <p className={css({ textStyle: 'Text/M/Strong', mt: 10, mb: 2 })}>
          <FormattedMessage id='Reward_hub.r260128.Total_reward_description2' />
        </p>
        <ul className={stack({ pl: 8, gap: 2 })}>
          <li>
            <FormattedMessage id='Reward_hub.r260128.Total_reward_description3' />
          </li>
          <li>
            <FormattedMessage id='Reward_hub.r260128.Total_reward_description4' />
          </li>
          <li>
            <FormattedMessage id='Reward_hub.r260128.Total_reward_description5' />
          </li>
        </ul>
      </Modal.Content>
    </Modal.Root>
  );
};
